"use client";

import { useLanguage } from "@/components/LanguageProvider";

type Props = {
  /** Extra classes (e.g. on dark maintenance backgrounds). */
  className?: string;
};

export function LanguageSwitcher({ className = "" }: Props) {
  const { lang, setLang, mode, t } = useLanguage();

  if (mode !== "both") return null;

  const next = lang === "en" ? "ar" : "en";

  return (
    <button
      onClick={() => setLang(next)}
      aria-label={t("lang.switch.aria")}
      className={`flex items-center gap-1 rounded-lg border border-slate-200/80 px-2.5 py-1 text-xs font-semibold text-slate-700 transition hover:border-[var(--accent)] hover:text-[var(--accent)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--accent)] ${className}`}
    >
      {t("lang.switch.to.ar")}
    </button>
  );
}
